module.exports = __webpack_public_path__ + "static/media/splash-screen-illustration.830f3661.png";